import { delayedTrackFacebookPixel } from '@blueberry/utils/analytics'
import { Flow, SignupData, SignupResponseSuccess } from '../types'
import { getLogger } from '@blueberry/observability'

declare global {
  interface Window {
    // facebook pixel
    fbq: (
      command: 'track' | 'init' | 'trackCustom',
      event: string,
      data?: unknown,
      options?: { eventID: string },
    ) => void
  }
}

const logger = getLogger('signup/analytics/meta')

export const meta = {
  trackStep(flow: Flow, step: number, _data: SignupData, eventID: string) {
    // no FB tracking for insurance flows currently
    if (flow !== 'd2c') return

    try {
      switch (step) {
        case 1:
          delayedTrackFacebookPixel('Signup Page #page1', eventID)
          break
        case 2:
          delayedTrackFacebookPixel('Signup Page #page2', eventID)
          break
        case 3:
          delayedTrackFacebookPixel('Signup Page #page3', eventID)
          break
      }
    } catch (error) {
      logger.error('Error tracking Meta step event:', error)
      return
    }
  },

  async trackSuccess(
    flow: Flow,
    _data: SignupData,
    response: SignupResponseSuccess,
    eventID: string,
  ) {
    // no FB tracking for insurance flows success currently
    if (flow !== 'd2c') return

    if (response.flow !== 'd2c') {
      throw new Error(
        `Incorrect response flow. Got ${response.flow}, expected d2c.`,
      )
    }

    const data = { value: response.totalPrice, currency: 'USD' }

    // This is a custom event to replace 'Purchase', 'AddToCart', and 'Lead' non-custom events due to the core setup restriction enforced on 2/14/2025
    // https://www.facebook.com/business/help/124742407297678
    try {
      window.fbq('trackCustom', 'Signup Success', data, {
        eventID: eventID,
      })
    } catch (error) {
      logger.error('Error tracking Meta success event:', error)
      return
    }
  },
}
